import { isNumber } from 'lodash'
import { EMPTY_VALUE_DASH } from '../../../constants'
import { numberToCurrency } from '../../../utils'
import { TradeFormValues } from '../Types'
import { getPrincipalAmount } from './getPrincipalAmount'
import { isBuy } from './isBuy'

export const getNetAmount = (values: TradeFormValues): number | undefined => {
  const {
    liquidityFee = 0,
    generalPurposeFee = 0,
    markUpMarkDown = 0,
    clientClearingFee = 0,
    tradeActivityFee = 0,
    commission = 0,
  } = values
  const principalAmount = getPrincipalAmount(values)
  return principalAmount
    ? principalAmount -
        commission -
        markUpMarkDown -
        clientClearingFee -
        generalPurposeFee -
        liquidityFee -
        tradeActivityFee
    : undefined
}

export const getNetAmountString = (values: TradeFormValues): string => {
  let netAmount = getNetAmount(values)
  if (values.action && netAmount && isBuy(values.action)) {
    netAmount = Math.abs(netAmount)
  }
  return isNumber(netAmount) ? numberToCurrency(netAmount, values.currency) : EMPTY_VALUE_DASH
}
